import { render, staticRenderFns } from "./HousesComponent.vue?vue&type=template&id=384e6e4a&scoped=true"
import script from "./HousesComponent.vue?vue&type=script&lang=js"
export * from "./HousesComponent.vue?vue&type=script&lang=js"
import style0 from "./HousesComponent.vue?vue&type=style&index=0&id=384e6e4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384e6e4a",
  null
  
)

export default component.exports